export default {
  'categories.shoes': 'Buty',
  'categories.hoodies': 'Bluzy i swetry',
  'categories.tshirts': 'Koszulki',
  'categories.jackets': 'Kurtki',
  'categories.pants': 'Spodnie i szorty',
  'categories.headwear': 'Nakrycia głowy',
  'categories.sets': 'Zestawy',
  'categories.underwear': 'Bielizna',
  'categories.jersey': 'Koszulki sportowe',
  'categories.accessories': 'Akcesoria',
  'categories.bags': 'Torby',
  'categories.belts': 'Paski',
  'categories.perfumes': 'Perfumy',
  'categories.other': 'Inne',

  'nav.guides': 'Poradniki',
  'nav.categories': 'Kategorie',
  'nav.shipping': 'Wysyłka',
  'nav.warehouse': 'Magazyn',
  'nav.coupons': 'Kupony',
  'nav.safety': 'Bezpieczeństwo',
  'nav.buyNow': 'Kup teraz',
  'nav.home': 'Strona główna',
  'nav.shoppingGuide': 'Poradnik zakupowy',
  'nav.about': 'O nas',

  'hero.eyebrow': 'CENTRUM ZASOBÓW USFANS SPREADSHEET',
  'hero.title': 'USFans Spreadsheet — znajdź, porównaj i poznaj zasoby szybciej',
  'hero.subtitle': 'Poznaj zasoby USFans spreadsheet, poradniki do badań produktów, recenzje, informacje o wysyłce, przewodniki po magazynie, kupony, wskazówki bezpieczeństwa i praktyczne tutoriale — wszystko w jednym miejscu.',
  'hero.ctaPrimary': 'Poznaj USFans Spreadsheet',
  'hero.ctaSecondary': 'Przeglądaj poradniki USFans',
  'hero.searchPlaceholder': 'Szukaj arkuszy, produktów, sprzedawców lub poradników...',
  'hero.trust': 'Niezależne źródło • Praktyczne poradniki • Regularnie aktualizowane',

  'trust.1.title': 'USFans Spreadsheet',
  'trust.1.desc': 'Uporządkowane zasoby i praktyczne informacje.',
  'trust.2.title': 'Badanie produktów',
  'trust.2.desc': 'Porównuj produkty, sprzedawców i przydatne zasoby.',
  'trust.3.title': 'Wysyłka i magazyn',
  'trust.3.desc': 'Zrozum wysyłkę, magazyn i realizację zamówień.',
  'trust.4.title': 'Bezpieczeństwo',
  'trust.4.desc': 'Sprawdzaj linki, sprzedawców, ceny i płatności.',

  'category.title': 'Przeglądaj kategorie produktów',
  'category.subtitle': 'Przejdź od razu do dowolnej kategorii na stronie głównej.',
  'category.dropdownLabel': 'Wybierz kategorię',
  'category.dropdownPlaceholder': 'Wybierz kategorię, aby kontynuować...',

  'about.title': 'Czym jest USFans Spreadsheet?',
  'about.copy': 'USFans spreadsheet to ustrukturyzowane narzędzie do porządkowania informacji o produktach, linków, sprzedawców, kategorii i powiązanych badań zakupowych. Naszym celem jest ułatwienie ich odkrywania, rozumienia i porównywania.',
  'about.cta': 'Dowiedz się, jak działają arkusze USFans',

  'explore.title': 'Twoje centrum badań USFans Spreadsheet',
  'explore.subtitle': 'Wszystko uporządkowane w jednym miejscu — od badań po bezpieczeństwo.',
  'explore.1.title': 'USFans Spreadsheet',
  'explore.2.title': 'Badanie produktów',
  'explore.3.title': 'Zasoby sprzedawców',
  'explore.4.title': 'Recenzje',
  'explore.5.title': 'Wysyłka',
  'explore.6.title': 'Magazyn',
  'explore.7.title': 'Kupony',
  'explore.8.title': 'Bezpieczeństwo',

  'guides.title': 'Popularne poradniki USFans',
  'guides.subtitle': 'Praktyczne, oryginalne poradniki, które pomogą Ci podejmować lepsze decyzje.',
  'guides.readMore': 'Przeczytaj poradnik',

  'pillars.eyebrow': 'Poradniki filarowe',
  'pillars.title': 'Przewodniki filarowe USFans Spreadsheet',
  'pillars.subtitle': 'Szczegółowe, oryginalne artykuły obejmujące podstawowe tematy — od podstaw po wyszukiwanie, produkty, sprzedawców i porównania.',

  'module.review.title': 'Recenzja USFans',
  'module.review.desc': 'Co warto wiedzieć przed użyciem — funkcje, wysyłka, magazyn i płatność.',
  'module.shipping.title': 'Poradnik kosztów wysyłki',
  'module.shipping.desc': 'Jak waga, miejsce docelowe i metoda wpływają na koszt wysyłki.',
  'module.coupon.title': 'Kupon i kod rabatowy',
  'module.coupon.desc': 'Jak działają kupony i gdzie sprawdzać aktualne promocje.',
  'module.warehouse.title': 'Poradnik magazynu',
  'module.warehouse.desc': 'Przechowywanie, kontrola, konsolidacja i pakowanie wyjaśnione.',
  'module.safety.title': 'Czy USFans jest legalny?',
  'module.safety.desc': 'Praktyczna lista kontrolna weryfikacji linków, sprzedawców i płatności.',

  'cta.title': 'Gotowy, aby poznać zasoby USFans Spreadsheet?',
  'cta.text': 'Zacznij od centrum USFans Spreadsheet, poznaj praktyczne poradniki i porównania, a następnie przejdź do strony głównej, gdy będziesz gotowy dowiedzieć się więcej.',
  'cta.primary': 'Poznaj USFans Spreadsheet',
  'cta.secondary': 'Odwiedź stronę główną',

  'footer.tagline': 'Niezależne centrum informacji o USFans Spreadsheet.',
  'footer.resources': 'Zasoby',
  'footer.company': 'Firma',
  'footer.legal': 'Informacje prawne',
  'footer.languages': 'Języki',
  'footer.disclaimer': 'Ta strona jest niezależnym źródłem informacji i niekoniecznie jest powiązana z USFans ani przez nią wspierana, chyba że wyraźnie to zaznaczono.',
};